import React, { FC, useEffect } from 'react';

import { Box,Button, Typography } from '@mui/material';

interface FileUploadProps {
    buttonName?: string;
    fileName: string | null;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FileUpload: FC<FileUploadProps> = ({ onChange, fileName, buttonName = 'Select File to Upload' }) => {

    useEffect(() => {
        if (fileName == null) {
            const input = document.getElementById('file-input') as HTMLInputElement;
            input.value = input.defaultValue;
        }
    }, [fileName]);

    return (
        <Box sx={{ textAlign: 'left' }}>
            <input
                type='file'
                id='file-input'
                accept='.csv'
                style={{ display: 'none' }}
                onChange={onChange}
            />
            {fileName && (
                <Typography variant='body1'>
                    Selected File: <strong>{fileName}</strong>
                </Typography>
            )}
            <label htmlFor='file-input'>
                <Button
                    variant='contained'
                    component='span'
                    color='primary'
                    sx={{ textTransform: 'none', mt: 2 }}
                >
                    {buttonName}
                </Button>
            </label>
        </Box>
    );
};
